<script setup lang="ts">
import type { Field } from '@/modules/Project/Fields/types'
import CircularProgress from '@/uiKit/CircularProgress.vue'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'

defineProps<{
  status: Field['status']
}>()

defineEmits<{
  (e: 'recompute' | 'recompute-mousedown'): void
}>()
</script>

<template>
  <div class="flex items-center justify-center p-0.5">
    <DarwinButton
      variant="transparent"
      size="xs"
      :class="status === 'computing' && 'pointer-events-none'"
      @click="$emit('recompute')"
      @mousedown="$emit('recompute-mousedown')"
    >
      <template #leading-icon>
        <CircularProgress
          v-if="status === 'computing'"
          size="xs"
        />
        <IconSprite
          v-else
          icon="refresh"
        />
      </template>
      <template #default> Recompute </template>
    </DarwinButton>
  </div>
</template>
